export function hasAnyTrueValue(object: Record<string, boolean>): boolean {
  return Object.values(object).includes(true);
}
